export enum ENTITY {
  VIEW = 'view',
  GANTT_CHART = 'gantChart',
  LIST_CONTROL = 'listControl',
  DROP_DOWN_ENTITY = 'dropdownEntity',
}

export const ENTITY_PATH: Record<ENTITY, string> = {
  view: 'VIEWS',
  gantChart: 'GANTT_CHART',
  listControl: 'LIST_CONTROLS',
  dropdownEntity: 'DROP_DOWN_ENTITY',
}

export const enum WINDOW_ENTITY {
  VIEW = 'VIEW',
  FORM = 'FORM',
  GANTT_CHART = 'GANTTCHART',
}

export enum ENTITY_TYPES_REQUEST {
  LIST_CONTROL = 'LIST_CONTROL',
  VIEW = 'DEFAULT',
  DROP_DOWN_ENTITY = 'DROP_DOWN_ENTITY',
  GANTT_CHART = 'GANTT_CHART',
  MENU = 'MENU',
  FORM = 'FORM',
  WINDOW = 'WINDOW',
  CONTEXT_MENU = 'CONTEXT_MENU',
  TOOLTIP = 'TOOLTIP',
  TIME_TABLE = 'TIME_TABLE',
}

export enum DROPDOWN_FILTER_TYPES {
  WINDOW = 'WINDOW',
  LIST = 'LIST',
}

export enum CLICK_EVENT_TYPE {
  EDIT_CLICK = 'EDIT_CLICK',
  CREATE_CLICK = 'CREATE_CLICK',
  ROW_CLICK = 'ROW_CLICK',
  CELL_CLICK = 'CELL_CLICK',
}

export enum ENTITY_CONFIG_TYPE {
  VARIABLES = 'variables',
  STYLE_SETTINGS = 'styleSettings',
  DISPLAY_RULES = 'displayRules',
  CONTROL_PANELS = 'controlPanels',
  CONTEXT_MENUS = 'contextMenus',
  VIEWS = 'views',
  VIEW_GROUPS = 'viewGroups',
  FORMS = 'forms',
  FORM_GROUPS = 'formGroups',
  GANTT_CHARTS = 'ganttCharts',
  SEARCH_ASSISTANTS = 'searchAssistants',
  CONTEXTS = 'contexts',
  WINDOWS = 'windows',
  DIAGRAMS = 'diagrams',
  TIMELINES = 'timelines',
  TOOLTIPS = 'tooltips',
  DICTIONARIES = 'dictionaries',
  MAPS = 'maps',
}

export enum CONFIG_MENU_OPTION {
  EXPORT = 'export',
  IMPORT = 'import',
  EDIT = 'edit',
}

export const CONFIG_MENU_TITLES: Record<CONFIG_MENU_OPTION, string> = {
  [CONFIG_MENU_OPTION.IMPORT]: 'Import CFG',
  [CONFIG_MENU_OPTION.EXPORT]: 'Export CFG',
  [CONFIG_MENU_OPTION.EDIT]: 'Edit CFG',
}

export const CONFIG_SCRIPT_VALUE_DIALOG_APPLY_BUTTON_TITLES: Record<CONFIG_MENU_OPTION, string> = {
  [CONFIG_MENU_OPTION.IMPORT]: 'Import',
  [CONFIG_MENU_OPTION.EXPORT]: 'Export',
  [CONFIG_MENU_OPTION.EDIT]: 'Save',
}

export const GRID_CELL_MODE = {
  VIEW: 'view',
  EDIT: 'edit',
}

export const CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID_FIELD_NAME =
  'CONFIGURED_ENTITY_DATA_GRID_ROW_SYSTEM_UNIQUE_ID'

export const SYSTEM_SELECT_COLUMN = 'SYSTEM_SELECT_COLUMN'
